export default "__VITE_ASSET__Brn2DVVV__"